export default "__VITE_ASSET__eDxrCrdg__"